export default __webpack_public_path__ + "static/media/tax.1867ac24.jpg";